import React, { useEffect } from 'react'
import AppLayout from 'components/layout/layout'
import './styles/styles.scss'
import { leagueEventStore } from 'state/league/leagueEvent'
import { leagueSteps } from './constants'
import Step1 from './screens/Step1/Step1'
import { infoMessage } from 'api/global'
import Step2 from './screens/Step2/Step2'
import Step4Divisions from './screens/Step4/Step4'
import Step3 from './screens/Step3/Step3'
import Step5 from './screens/Step5/Step5'
import Step6 from './screens/Step6/Step6'
import Step7 from './screens/Step7/Step7'
import { useGetLeagueById } from 'api/league/LeagueCreation/leagueCreation'
import { useParams } from 'react-router-dom'
import { daysOfWeek, forceRefetch } from 'helper/utility'
import { useQueryClient } from '@tanstack/react-query'
import Spinner from 'components/Spinner'
import Step8 from './screens/Step8/Step8'

const CreateLeague: React.FC = () => {
  const queryClient = useQueryClient()
  const {
    leagueStepCounter,
    setLeagueStepCounter,
    setLeagueData,
    setRequiredDetails,
    setTimeSlots,
  } = leagueEventStore(store => ({
    leagueStepCounter: store.leagueStepCounter,
    setLeagueStepCounter: store.setLeagueStepCounter,
    setLeagueData: store.setLeagueData,
    setRequiredDetails: store.setRequiredDetails,
    setTimeSlots: store.setTimeSlots,
  }))
  const { id }: { id: string } = useParams()

  const {
    data: leagueData,
    isLoading: getLeagueLoading,
    isFetching: getLeagueFetching,
    refetch: refetchLeague,
  } = useGetLeagueById(id)

  const handleNextClick = () => {
    if (leagueStepCounter === leagueSteps.length) {
      return infoMessage('You have reached the end of the wizard')
    } else {
      setLeagueStepCounter(leagueStepCounter + 1)
    }
  }

  const handleBackClick = () => {
    if (leagueStepCounter === 0) {
      return infoMessage('You have reached the start of the wizard')
    } else {
      setLeagueStepCounter(leagueStepCounter - 1)
    }
  }

  useEffect(() => {
    if (id) {
      refetchLeague()
    }
  }, [])

  useEffect(() => {
    if (id) {
      setLeagueData(leagueData)
      setRequiredDetails((leagueData as any)?.requiredDetails)
      setRequiredDetails((leagueData as any)?.requiredDetails)
      if (leagueData?.timeSlots) {
        const extractedTimeSlots = daysOfWeek.reduce(
          (acc, day) => {
            if (Array.isArray(leagueData?.timeSlots[day])) {
              acc[day] = leagueData?.timeSlots[day].map(({ start, end }) => ({
                start,
                end,
              }))
            }
            return acc
          },
          {} as Record<string, { start: number; end: number }[]>,
        )
        setTimeSlots(extractedTimeSlots)
      } else {
        setTimeSlots(null)
      }
    } else {
      forceRefetch('event-detail-by-id', queryClient)
    }
  }, [leagueData, id])

  if (id && (getLeagueLoading || getLeagueFetching)) {
    return (
      <div className="flex align-center justify-center py-40px">
        <Spinner />
      </div>
    )
  }

  return (
    <>
      <AppLayout id={id}>
        <div className="create-league-main-content-wapper w-100">
          <div className="create-league-main-content-cotainer">
            <h2 className="text-24 w-600">
              Step {leagueStepCounter + 1}. {leagueSteps[leagueStepCounter]}
            </h2>
            <div className="mt-20px">
              {leagueStepCounter === 0 && (
                <Step1
                  handleNext={handleNextClick}
                  handleBack={handleBackClick}
                />
              )}
              {/* {leagueStepCounter === 1 && (
              <Step2
                handleNext={handleNextClick}
                handleBack={handleBackClick}
              />
            )} */}
              {leagueStepCounter === 1 && (
                <Step2
                  handleNext={handleNextClick}
                  handleBack={handleBackClick}
                />
              )}
              {leagueStepCounter === 2 && (
                <Step3
                  handleNext={handleNextClick}
                  handleBack={handleBackClick}
                />
              )}
              {leagueStepCounter === 3 && (
                <Step4Divisions
                  handleNext={handleNextClick}
                  handleBack={handleBackClick}
                />
              )}
              {leagueStepCounter === 4 && (
                <Step5
                  handleNext={handleNextClick}
                  handleBack={handleBackClick}
                />
              )}
              {leagueStepCounter === 5 && (
                <Step6
                  handleNext={handleNextClick}
                  handleBack={handleBackClick}
                />
              )}
              {leagueStepCounter === 6 && (
                <Step7
                  handleNext={handleNextClick}
                  handleBack={handleBackClick}
                />
              )}
              {leagueStepCounter === 7 && (
                <Step8 handleBack={handleBackClick} />
              )}
            </div>
          </div>
        </div>
      </AppLayout>
    </>
  )
}

export default CreateLeague
